var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/modules/_uid.js
// module id = 57
// module chunks = 0